import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';
import { POST_CLOSING_OPTIONS_ACTION_TYPE } from 'store/system/actions';

const initialState = {
  effectiveByListType: {},
  adminByListType: {},
};

const postClosingOptionsReducer = (state = initialState, { type, payload, meta }) =>
  produce(state, draft => {
    switch (type) {
      case POST_CLOSING_OPTIONS_ACTION_TYPE.GET_OPTIONS:
        draft.effectiveByListType[meta.listType] = payload ?? [];
        break;

      case POST_CLOSING_OPTIONS_ACTION_TYPE.GET_ADMIN_OPTIONS:
        draft.adminByListType[meta.listType] = {
          usingDefaults: !!payload?.usingDefaults,
          items: payload?.items ?? [],
        };
        break;

      case RESET_STATE:
        draft.adminByListType = initialState.adminByListType;
        break;

      default:
        return state;
    }
  });

export default postClosingOptionsReducer;
